/** Hostname without port (e.g. dev.showmethemenu.net). Accepts a host or a full URL. */
export function pageHostname(host) {
  let raw = host || (typeof window !== 'undefined' && window.location && (window.location.hostname || window.location.host)) || '';
  raw = String(raw).toLowerCase().trim();
  if (raw.indexOf('://') !== -1) {
    raw = raw.replace(/^https?:\/\//, '');
  }
  return raw.split('/')[0].split(':')[0];
}

/**
 * Shared portal hosts: restaurant list / platform paths, not a single-merchant custom domain.
 * Any *.showmethemenu.net (including dev.showmethemenu.net) is the portal.
 */
export function isPlatformHost(host) {
  const h = pageHostname(host);
  if (!h) {
    return false;
  }
  if (h === 'eemo.app' || h.endsWith('.eemo.app')) {
    return true;
  }
  return h === 'showmethemenu.net' || h.endsWith('.showmethemenu.net');
}

/** Direct webpack-dev-server / LAN access over HTTP (no TLS). */
export function isLanDevHost(host) {
  const h = pageHostname(host);
  return h === 'localhost' || h === '127.0.0.1' || h === '10.0.100.11' || h === '80.209.154.54';
}

/** Booking channel for a customer page. K-Points hosts are separate from the SMTM website. */
export function bookingChannelSource(host) {
  const h = pageHostname(host);
  if (h === 'k-points.co.uk' || h.endsWith('.k-points.co.uk')) {
    return 'K-Points';
  }
  return 'Website';
}



// WEBPACK FOOTER //
// ./src/api/hosts.js